import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import GravityFormForm from 'gatsby-plugin-gravity-forms'
import Link from 'Components/Link'
import Container from 'Containers/Container'
import addTrackingEvent from 'Utils/addTrackingEvent'
import { footer, formStyle, formInner, legal } from './style.module.scss'
import './form.scss'

const Footer = ({ newsletter }) => {
    const triggerEvent = () => {
        addTrackingEvent({
            data: {
                name: 'Newsletter',
            },
            event: 'Form',
        })
    }

    let newsletterContent = newsletter?.newsletterBlurb
    let newsletterTitle = newsletter?.newsletterTitle
    if (!newsletterTitle) {
        newsletterTitle = 'Helpful Bits Straight Into Your Inbox'
    }
    if (!newsletterContent) {
        newsletterContent =
            '<p>Subscribe to the newsletter for insights and helpful pieces on React, Gatsby, Next JS, Headless WordPress, and Jest testing.</p>'
    }

    return (
        <StaticQuery
            query={graphql`
                query {
                    wpGfForm(databaseId: { eq: 1 }) {
                        ...GravityFormFields
                    }
                }
            `}
            render={({ wpGfForm }) => (
                <footer className={footer}>
                    <div id="subscribe" className={formStyle}>
                        <Container>
                            <div className={formInner}>
                                <h2>{newsletterTitle}</h2>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: newsletterContent,
                                    }}
                                />

                                <div className="footerForm">
                                    <GravityFormForm
                                        data={wpGfForm}
                                        successCallback={triggerEvent}
                                    />
                                </div>
                            </div>
                        </Container>
                    </div>
                    <div className={legal}>
                        <Container>
                            By <Link to="/">Robert Marshall</Link> &{' '}
                            <a href="https://www.gatsbyjs.org/">Gatsby</a>
                        </Container>
                    </div>
                </footer>
            )}
        />
    )
}

export default Footer
